export default __webpack_public_path__ + "static/media/mew.2a120bba.png";